import React, {createContext, useEffect, useState, use} from "react";
import PropTypes from "prop-types";

const FeatureFlagContext = createContext({setFeatureFlags: () => {}});

export const FeatureFlagProvider = ({children}) => {
  const [featureFlags, setFeatureFlags] = useState(false);

  useEffect(() => {
    setFeatureFlags({
      showDeveloper: process.env.DEVELOPER_FLAG === "true",
      showGettingStarted: true,
      newSidebarDesign: false,
      showScratchPad: false,
      setFeatureFlags,
    });
  }, []);

  return <FeatureFlagContext value={featureFlags}>{children}</FeatureFlagContext>;
};

FeatureFlagProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFeatureFlags = () => {
  return use(FeatureFlagContext);
};
